const GRID_STYLE_PROPS_DATA = {
  gap: { type: "spacing", property: "gap" },
  rowGap: { type: "spacing", property: "rowGap" },
  columnGap: { type: "spacing", property: "columnGap" },
  columns: { type: "identity", property: "gridTemplateColumns" },
  autoRows: { type: "identity", property: "gridAutoRows" },
  autoFlow: { type: "identity", property: "gridAutoFlow" },
  templateRows: { type: "identity", property: "gridTemplateRows" },
  templateAreas: { type: "identity", property: "gridTemplateAreas" },
  templateColumns: { type: "identity", property: "gridTemplateColumns" },
  justifyItems: { type: "identity", property: "justifyItems" },
  alignItems: { type: "identity", property: "alignItems" },
  justifyContent: { type: "identity", property: "justifyContent" },
  alignContent: { type: "identity", property: "alignContent" }
};

export { GRID_STYLE_PROPS_DATA };
